<template>
    <div class="iframe-wrapper">
        <div class="iframe-container" v-if="subContainer==false" 
        :class="{'modal-container-xxl':containerxxl==true,
        'modal-container-xl':containerxl==true,
        'modal-container-md':containermd==true,
        'modal-container-sm':containersm==true}">
            <div class="titleclass h-auto d-flex justify-content-between py-2 px-3">
            <h4 class="my-0"> <slot name="title">Default Title</slot></h4>
            <div class="close-link" v-if="hideClose==false">
                <slot name="subHeaderPart" v-if="subHeaderPart==true">Default subHeader</slot>
                    <span class="tooltip-wrapper pointer" >
                        <span class="cursor-pointer" @click.prevent="closeModal()"><i class="fa fa-times" ></i></span>
                        <span class="custom-tooltip closetooltipposition">{{$t('navigations.close')}}</span>
                    </span>

                
            </div>
        </div> 
            <div class="iframe-body py-2 px-4" :class="{'body-xl':bodyxl==true,'body-md':bodymd==true,'dynamicbody-xl':dynamicbodyxl==true,'custom-position-relative':positionRelative==true}" >
                <slot name="body">Nothing to display</slot>
            </div>
            <div class="iframe-footer py-2 px-4" v-if="footerShow==true">
                <slot name="footer" ></slot>
            </div>
        </div>
        <div class="iframe-container" v-else>
            <div class="titleclass h-auto d-flex justify-content-between py-2 px-3">
            <h4 class="my-0"> <slot name="subContainerTitle">Default Title</slot></h4>
            <div class="close-link">
                <slot name="subHeaderPart" v-if="subHeaderPart==true">Default subHeader</slot>
                <span class="tooltip-wrapper pointer" >
                    <span class="cursor-pointer" @click.prevent="closeModal()"><i class="fa fa-times" ></i></span>
                    <span class="custom-tooltip closetooltipposition">{{$t('navigations.close')}}</span>
                </span>
            </div>
        </div> 
            <div class="iframe-body py-2 px-4" :class="{'width-height':bodyxl==true,'height-300':bodymd==true,'custom-position-relative':positionRelative==true}">
                <slot name="subContainerBody">Nothing to display</slot>
            </div>
            <div class="iframe-footer px-4 border-top" style="border-top: 1px solid #f5f5f5;" v-if="footerShow==true">
                <slot name="subContainerFooter" ></slot>
            </div>
        </div>
    </div>
</template>
<script src="./customModal.js"></script>
  <style scoped>
  @import "../../assets/css/style.css";
  .iframe-wrapper {
  position: fixed;
  display: flex;
  justify-content:center;
  align-items: center;
  inset: 0;
  background: rgb(0 0 0 / 30%);
  transition: cubic-bezier;
  overflow: hidden;
  z-index: 10000;
}
.closetooltipposition{
  bottom: -10px !important;
  margin-left: -75px !important;
}

.iframe-container {

  background: #fff;
  border-radius: 6px;
  transition: all 0.3s ease-in-out;
  box-shadow: 3px 6px 6px rgba(16, 24, 40, .1);
}
.body-xxl {
  height: 600px;
  overflow: auto;
}
.body-xl {
  height: 500px;
  overflow: auto;
}

.body-md{
  height:calc(100vh - 11rem);
  overflow-y: scroll;
}

.body-sm{
  height:auto;
  overflow-y: scroll;
}

.dynamicbody-xl{
  height:calc(100vh - 9rem);
  overflow-y: scroll;
}
/* Container styles  */

.modal-container-sm{
    width:min(500px,90%)
}
.modal-container-md
{
    width: min(800px, 90%);
}
.modal-container-xl{
    width: min(900px, 90%);
}
.modal-container-xxl{
    width: min(1200px, 90%);
}

.custom-position-relative{
    position: relative
}
/* Container styles  */
  </style>
  